const sortFuncDate = (a, b, order, dataField, rowA, rowB) => {
  if (order === 'asc') {
    return Date.parse(a) - Date.parse(b);
  } else if (order === 'desc') {
    return Date.parse(b) - Date.parse(a);
  }
};

export default sortFuncDate;
